import React from 'react';
import { PlayerInfo } from './profile/PlayerInfo';
import { VideoSection } from './profile/VideoSection';
import { PlayerBio } from './profile/PlayerBio';
import { StatisticsSection } from './profile/StatisticsSection';
import { PreviousTeamsSection } from './profile/PreviousTeamsSection';
import { AwardsSection } from './profile/AwardsSection';
import { AcademicInfo } from './profile/AcademicInfo';

// Same card order as the public player preview, plus the sections only the
// player edits (previous teams).
export const PlayerProfileContent = () => {
  return (
    <main className="px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="lg:col-span-2 min-w-0">
        <PlayerInfo />
      </div>

      <div className="lg:col-span-2 min-w-0">
        <StatisticsSection />
      </div>

      <div id="player-videos" className="lg:col-span-2 min-w-0 scroll-mt-24">
        <VideoSection />
      </div>

      <PlayerBio />
      <AwardsSection />

      <div className="lg:col-span-2 min-w-0">
        <PreviousTeamsSection />
      </div>

      <div className="lg:col-span-2 min-w-0">
        <AcademicInfo />
      </div>
      </div>
    </main>
  );
};

export default PlayerProfileContent;
